var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GoldenLayout } from 'golden-layout';
import { setupProgramEditor, setupReplOutput, setupReplInput, layout as resizeEditors } from './editor';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { storage } from './storage';
export var config = {
    settings: {
        hasHeaders: true,
        reorderEnabled: true,
        showMaximiseIcon: false,
    },
    dimensions: {
        borderWidth: 2,
        headerHeight: 20,
    },
    root: {
        type: 'column',
        content: [
            {
                type: 'row',
                content: [
                    {
                        type: 'component',
                        componentType: 'program',
                        isClosable: false,
                        title: 'Program',
                        id: 'program-tab',
                    },
                    {
                        type: 'column',
                        content: [
                            {
                                type: 'component',
                                componentType: 'eval',
                                isClosable: false,
                                title: 'Evaluation',
                                id: 'eval-tab',
                            },
                            {
                                type: 'component',
                                componentType: 'input',
                                isClosable: false,
                                title: 'Input',
                                height: 10,
                                id: 'input-tab',
                                // hasHeaders: false,
                            },
                            {
                                type: 'component',
                                componentType: 'topbar',
                                isClosable: false,
                                height: 5,
                                title: 'Color Theme',
                                // hasHeaders: false,
                            },
                        ]
                    }
                ]
            }
        ]
    }
};
var clickCount = 0;
var win = null;
var layout = null;
import themeList from 'monaco-themes/themes/themelist.json';
export var editorThemes = [];
export function initLayout() {
    return __awaiter(this, void 0, void 0, function () {
        var glContainer, gl, renderHTML;
        var _this = this;
        return __generator(this, function (_a) {
            glContainer = document.getElementById('golden-layout');
            gl = new GoldenLayout(glContainer);
            renderHTML = function (src) {
                var template = document.createElement('template');
                template.innerHTML = src.trim();
                return [template.content.firstChild, template.content.childNodes[0]];
            };
            gl.registerComponentFactoryFunction('program', function (container, itemConfig) {
                var _a = __read(renderHTML("<div id=\"container\" style=\"height:100%;\"></div>"), 2), el = _a[0], htmlEl = _a[1];
                container.element.appendChild(el);
                // container.setTitle('Program');
                var htmlElem = htmlEl;
                setupProgramEditor(htmlElem, {
                    tabSize: 2
                });
            });
            gl.registerComponentFactoryFunction('eval', function (container, itemConfig) {
                var _a = __read(renderHTML("<div id=\"eval-container\" style=\"height:100%;\"></div>"), 2), el = _a[0], htmlEl = _a[1];
                container.element.appendChild(el);
                // container.setTitle('Evaluation');
                var htmlElem = htmlEl;
                setupReplOutput(htmlElem);
            });
            gl.registerComponentFactoryFunction('input', function (container, itemConfig) {
                var _a = __read(renderHTML("<div id=\"input-container\" style=\"height:100%;\"></div>"), 2), el = _a[0], htmlEl = _a[1];
                container.element.appendChild(el);
                // container.parent.headerConfig.show(false);
                var htmlElem = htmlEl;
                setupReplInput(htmlElem);
            });
            gl.registerComponentFactoryFunction('topbar', function (container, itemConfig) {
                var _a = __read(renderHTML("<div id=\"topbar-container\" style=\"height:100%;\"></div>"), 2), el = _a[0], htmlEl = _a[1];
                container.element.appendChild(el);
                var htmlElem = htmlEl;
                var _b = __read(renderHTML("<select class=\"theme-selector\" id=\"select-theme\"></select>"), 2), e = _b[0], htmlE = _b[1];
                el.appendChild(e);
                (function () { return __awaiter(_this, void 0, void 0, function () {
                    var themeData, fetches, themes, themes_1, themes_1_1, _a, name_1, path, theme, opt;
                    var e_1, _b;
                    var _this = this;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                themeData = {};
                                fetches = Object.entries(themeList).map(function (_a) {
                                    var _b = __read(_a, 2), name = _b[0], path = _b[1];
                                    return __awaiter(_this, void 0, void 0, function () {
                                        var data, tm;
                                        return __generator(this, function (_c) {
                                            switch (_c.label) {
                                                case 0:
                                                    console.log(name, path);
                                                    return [4 /*yield*/, import("monaco-themes/themes/".concat(path, ".json"))];
                                                case 1:
                                                    data = _c.sent();
                                                    themeData[name] = data;
                                                    tm = { name: name, path: path, theme: data };
                                                    editorThemes.push(tm);
                                                    return [2 /*return*/, tm];
                                            }
                                        });
                                    });
                                });
                                return [4 /*yield*/, Promise.all(fetches)];
                            case 1:
                                themes = _c.sent();
                                try {
                                    for (themes_1 = __values(themes), themes_1_1 = themes_1.next(); !themes_1_1.done; themes_1_1 = themes_1.next()) {
                                        _a = themes_1_1.value, name_1 = _a.name, path = _a.path, theme = _a.theme;
                                        opt = document.createElement('option');
                                        opt.value = name_1;
                                        opt.text = path;
                                        htmlE.appendChild(opt);
                                        monaco.editor.defineTheme(name_1, theme);
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (themes_1_1 && !themes_1_1.done && (_b = themes_1.return)) _b.call(themes_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                                document.getElementById('select-theme').addEventListener('change', function (event) {
                                    var e_2, _a, e_3, _b, e_4, _c;
                                    var value = document.getElementById('select-theme').value; // (typeof event === 'string') ? event : (event as any).target.value;
                                    storage.setItem('user-theme', value);
                                    monaco.editor.setTheme(value);
                                    var replBGColor = themeData[value]['colors']['editor.background'];
                                    var container = document.getElementById('eval-container');
                                    // container.classList.add('eval-output-window');
                                    var backgrounds = __spreadArray(__spreadArray(__spreadArray([], __read(container.querySelectorAll('.monaco-editor-background')), false), __read(container.querySelectorAll('.monaco-editor')), false), __read(container.querySelectorAll('.margin')), false);
                                    try {
                                        for (var backgrounds_1 = __values(backgrounds), backgrounds_1_1 = backgrounds_1.next(); !backgrounds_1_1.done; backgrounds_1_1 = backgrounds_1.next()) {
                                            var bg = backgrounds_1_1.value;
                                            bg.style.backgroundColor = replBGColor;
                                            // bg.style.cssText += `background-color: ${replBGColor} !important;`;
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (backgrounds_1_1 && !backgrounds_1_1.done && (_a = backgrounds_1.return)) _a.call(backgrounds_1);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                    container = document.getElementById('input-container');
                                    backgrounds = __spreadArray(__spreadArray(__spreadArray([], __read(container.querySelectorAll('.monaco-editor-background')), false), __read(container.querySelectorAll('.monaco-editor')), false), __read(container.querySelectorAll('.margin')), false);
                                    try {
                                        for (var backgrounds_2 = __values(backgrounds), backgrounds_2_1 = backgrounds_2.next(); !backgrounds_2_1.done; backgrounds_2_1 = backgrounds_2.next()) {
                                            var bg = backgrounds_2_1.value;
                                            bg.style.backgroundColor = replBGColor;
                                            // bg.style.cssText += `background-color: ${replBGColor} !important;`;
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (backgrounds_2_1 && !backgrounds_2_1.done && (_b = backgrounds_2.return)) _b.call(backgrounds_2);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                    container = document.getElementById('topbar-container');
                                    backgrounds = __spreadArray(__spreadArray(__spreadArray([container], __read(container.querySelectorAll('#topbar-container')), false), __read(container.querySelectorAll('.theme-selector')), false), __read(container.querySelectorAll('.margin')), false);
                                    try {
                                        for (var backgrounds_3 = __values(backgrounds), backgrounds_3_1 = backgrounds_3.next(); !backgrounds_3_1.done; backgrounds_3_1 = backgrounds_3.next()) {
                                            var bg = backgrounds_3_1.value;
                                            bg.style.backgroundColor = replBGColor;
                                            bg.style.color = themeData[value]['colors']['editor.foreground'];
                                            // bg.style.cssText += `background-color: ${replBGColor} !important;color: ${themeData[value]['colors']['editor.foreground']} !important;`;
                                        }
                                    }
                                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                    finally {
                                        try {
                                            if (backgrounds_3_1 && !backgrounds_3_1.done && (_c = backgrounds_3.return)) _c.call(backgrounds_3);
                                        }
                                        finally { if (e_4) throw e_4.error; }
                                    }
                                    document.getElementById('style-mutator').innerHTML = "body,html{background-color: ".concat(replBGColor, "; color: ").concat(themeData[value]['colors']['editor.foreground'], "; background: ").concat(replBGColor, "; }");
                                });
                                return [2 /*return*/];
                        }
                    });
                }); })().then(function () {
                    var selector = document.getElementById('select-theme');
                    selector.value = storage.getItem('user-theme') || 'katzenmilch';
                    selector.dispatchEvent(new Event('change'));
                });
            });
            gl.loadLayout(config);
            layout = gl;
            window.addEventListener('resize', function () {
                layout.updateSize(window.innerWidth, window.innerHight);
                resizeEditors();
            });
            return [2 /*return*/];
        });
    });
}
